<section class="courses-page">
  <!-- HEADER -->
  <div class="page-header">
    <div>
      <h1>Courses</h1>
      <p>Manage all courses across bundles</p>
    </div>

	<ng-container *hasPermission="PermissionForStudents.COURSE_CREATE">
    <button class="add-btn" (click)="onAddCourse()">
      <span class="material-icons">add</span>
      Add Course
    </button>
</ng-container>
  </div>

  <!-- SUB HEADER -->
  <div class="sub-header">
    <h2>
      Manage Courses
      <span class="count">{{ totalCourses }}</span>
    </h2>
  </div>


  <!-- 🔄 SKELETON LOADER -->
  <div class="course-grid" *ngIf="loading">
    <div class="course-card skeleton" *ngFor="let _ of [].constructor(limit)">
      <div class="skeleton-header">
        <div class="skeleton-icon"></div>
        <div class="skeleton-badge"></div>
      </div>

      <div class="skeleton-line title"></div>
      <div class="skeleton-line small"></div>
      <div class="skeleton-btn"></div>
    </div>
  </div>


  <!-- EMPTY STATE -->
  <div class="no-data" *ngIf="!loading && courses.length === 0">
    <span class="material-icons no-data-icon">menu_book</span>
    <h3>No courses created yet</h3>
    <p>Start by creating your first course to organize content and lessons.</p>

	<ng-container *hasPermission="PermissionForStudents.COURSE_CREATE">
    <button class="add-btn" (click)="onAddCourse()">
      <span class="material-icons">add</span>
      Create First Course
    </button>
	</ng-container>
  </div>

  <!-- COURSE GRID -->
  <div class="course-grid" *ngIf="courses.length > 0">

    <div class="course-card" *ngFor="let course of courses">

      <div class="card-top">
        <div class="icon">
          <span class="material-icons">description</span>
        </div>

        <span class="status" [ngClass]="course.status">
          {{ course.status | titlecase }}
        </span>

        <!-- ⋮ Menu -->
		<ng-container *hasPermission="[PermissionForStudents.COURSE_DELETE , PermissionForStudents.COURSE_UPDATE]">
        <div class="menu-wrapper">
          <button class="menu-btn" (click)="toggleMenu(course.id); $event.stopPropagation()">
            <span class="material-icons">more_vert</span>
          </button>

          <div class="menu-dropdown" *ngIf="openMenuId === course.id">
            <!-- <button class="menu-item" (click)="onEditCourse(course)">
              <span class="material-icons">edit</span>
              Edit
            </button> -->

            <button class="menu-item danger" (click)="onDeleteCourse(course)">
              <span class="material-icons">delete</span>
              Delete
            </button>

          </div>
        </div>
		</ng-container>
      </div>


      <h3 class="truncate" matTooltip="{{course.title}}">{{ course.title }}</h3>

      <div class="units">
        <span class="material-icons">menu_book</span>
        Classroom: {{ course.classroom }}
      </div>

      <button class="view-btn" (click)="onViewCourse(course)">
        <span class="material-icons">open_in_new</span>
        View Course
      </button>
    </div>
  </div>
</section>

<div class="pagination-wrapper" *ngIf="totalRecords > limit && !loading">

  <button class="nav-btn" [disabled]="page === 1" (click)="changePage(page - 1)">
    ‹
  </button>

  <div class="page-pill">
    <button *ngFor="let p of visiblePages" class="page-number" [class.active]="p === page" (click)="changePage(p)">
      {{ p }}
    </button>
  </div>

  <button class="nav-btn" [disabled]="page === totalPages" (click)="changePage(page + 1)">
    ›
  </button>

</div>
<div class="pagination-skeleton" *ngIf="loading">
  <span></span>
  <span></span>
  <span></span>
</div>